import client from './client';
import qs from 'qs';

// 결재 V2(결재선 템플릿/위임·대결/전결) API. ksm_frontend lib/api/approvalV2.js 포팅
// (2026-10-20 결재 V2 이관) + bito 전용 범용 submit/approve/reject/recall/finalApprove
// (백엔드 ApprovalV2Controller가 문서종류와 무관하게 처리 - ApprovalCompletionHandler
// 레지스트리가 뒷단에서 문서종류별 후처리로 나눠준다).
const baseUrl = '/api/v1/common/approval/v2';

export const getApprovalV2Lines = (params) =>
  client.get(`${baseUrl}/lines?${qs.stringify(params)}`);

export const getApprovalV2Line = (lineId) => client.get(`${baseUrl}/lines/${lineId}`);

export const addApprovalV2Line = (data) => client.post(`${baseUrl}/lines`, data);

export const editApprovalV2Line = (lineId, data) =>
  client.put(`${baseUrl}/lines/${lineId}`, data);

export const removeApprovalV2Line = (lineId) => client.delete(`${baseUrl}/lines/${lineId}`);

export const getApprovalV2Inbox = (params) =>
  client.get(`${baseUrl}/inbox?${qs.stringify(params)}`);

export const getApprovalV2Submitted = (params) =>
  client.get(`${baseUrl}/submitted?${qs.stringify(params)}`);

export const getApprovalV2Document = (apprDocId) =>
  client.get(`${baseUrl}/documents/${apprDocId}`);

export const getApprovalV2DocumentByRef = (params) =>
  client.get(`${baseUrl}/documents/ref?${qs.stringify(params)}`);

export const submitApprovalV2Document = (data) => client.post(`${baseUrl}/documents`, data);

// 결재 모니터링(V2) - 관리자 전용, 제출자 무관 전체 문서(docType/docStatus 필터).
// 2026-10-20 결재 V2 이관 후속(4절 과제).
export const getAllApprovalV2Documents = (params) =>
  client.get(`${baseUrl}/documents?${qs.stringify(params)}`);

export const approveApprovalV2Document = (apprDocId, actionComment) =>
  client.post(`${baseUrl}/documents/${apprDocId}/approve`, { actionComment });

export const rejectApprovalV2Document = (apprDocId, actionComment) =>
  client.post(`${baseUrl}/documents/${apprDocId}/reject`, { actionComment });

export const recallApprovalV2Document = (apprDocId) =>
  client.post(`${baseUrl}/documents/${apprDocId}/recall`);

export const finalApproveApprovalV2Document = (data) =>
  client.post(`${baseUrl}/documents/final-approve`, data);

export const getApprovalV2Delegations = () => client.get(`${baseUrl}/delegations/my`);

export const addApprovalV2Delegation = (data) => client.post(`${baseUrl}/delegations`, data);

export const editApprovalV2Delegation = (delegationId, data) =>
  client.put(`${baseUrl}/delegations/${delegationId}`, data);

export const removeApprovalV2Delegation = (delegationId) =>
  client.delete(`${baseUrl}/delegations/${delegationId}`);

export const getApprovalV2Auths = (params) =>
  client.get(`${baseUrl}/auths?${qs.stringify(params)}`);

export const getApprovalV2AuthManagePermission = () =>
  client.get(`${baseUrl}/auths/manage-permission`);

export const getMyFinalApprovalAuth = (params) =>
  client.get(`${baseUrl}/auths/my-final?${qs.stringify(params)}`);

export const addApprovalV2Auth = (data) => client.post(`${baseUrl}/auths`, data);

export const editApprovalV2Auth = (authId, data) => client.put(`${baseUrl}/auths/${authId}`, data);

export const removeApprovalV2Auth = (authId) => client.delete(`${baseUrl}/auths/${authId}`);
